import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const slideInPaneWithoutOverlay = css`
  #remedySlideInPane > div:first-of-type {
    display: none;
  }

  #remedySlideInPane > div:last-of-type {
    top: calc(${sizes.xxLarge} - 1px);
    border-color: ${colors.gray2};
    z-index: 2;
  }
`;

export const HeaderButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  flex: 1;
`;

export const FooterButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const SelectedTypography = styled(StandardTypography)`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
`;
